module.exports = __webpack_public_path__ + "static/media/icon-global-delivery.6306a5c7.svg";